import Alpine from 'alpinejs'

Alpine.data('contactAgreement', (token, projectSlug) => ({
    isWorking: false,
    saved: false,
    token,
    projectSlug,

    grant(type, value) {
        this.isWorking = true

        fetch(`/api/up/${this.projectSlug}/contributor/${this.token}/agreement`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ type, value }),
        })
            .then((res) => {
                this.saved = res.ok
            })
            .finally(() => {
                this.isWorking = false
            })
    },
}))
